import { Col, Row } from 'react-bootstrap';
import { Card } from 'shared/components';
import {
  ButtonPlaceholder,
  InputPlaceholder,
  TextPlaceholder,
} from 'shared/placeholders';

export const UserFormSkeleton = () => (
  <>
    <Row className="mb-3">
      <Col>
        <Card>
          <Card.Title>Datos del usuario</Card.Title>
          <Card.Body $padding>
            <Row className="mb-2">
              <Col>
                <InputPlaceholder />
              </Col>
              <Col>
                <InputPlaceholder />
              </Col>
            </Row>
            <Row>
              <Col md="12">
                <InputPlaceholder />
              </Col>
            </Row>
          </Card.Body>
        </Card>
      </Col>
    </Row>
    <Row className="mb-3">
      <Col>
        <Card>
          <Card.Title>Informacion que puede consultar</Card.Title>
          <Card.Body $padding>
            <Row className="mb-2">
              <Col>
                <InputPlaceholder />
              </Col>
            </Row>

            <InputPlaceholder />
          </Card.Body>
        </Card>
      </Col>
    </Row>
    <Row className="mb-3">
      <Col>
        <Card>
          <Card.Title>Funcionalidades</Card.Title>
          <Card.Body $padding>
            <Row className="mb-3">
              <Col md="12">
                <TextPlaceholder height={24} />
                <TextPlaceholder />
              </Col>
            </Row>
            <Row className="mb-3">
              <Col md="12">
                <TextPlaceholder height={24} />
                <TextPlaceholder />
              </Col>
            </Row>
            <Row className="mb-3">
              <Col md="12">
                <TextPlaceholder height={24} />
                <TextPlaceholder />
              </Col>
            </Row>
            <Row className="mb-3">
              <Col md="12">
                <TextPlaceholder height={24} />
                <TextPlaceholder />
              </Col>
            </Row>
            <Row>
              <Col md="12">
                <TextPlaceholder height={24} />
                <TextPlaceholder />
              </Col>
            </Row>
            <Row>
              <Col className="text-end">
                <ButtonPlaceholder> Modificar </ButtonPlaceholder>
              </Col>
            </Row>
          </Card.Body>
        </Card>
      </Col>
    </Row>
  </>
);
